var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{attrs:{"id":_vm.id,"novalidate":"","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }